(ns ui.openrouter.devtools
  "The only way into the OpenRouter sidebar panel, and on purpose not a
   way our users can find.

   The panel is registered under the `:openrouter` sidebar key, which no
   button, menu or route sets. The feature therefore ships to production
   fully deployed and completely invisible: nothing to document in the
   help center, no video to record, no support questions — while we run
   real generations against the real backend on the real production
   data.

   Open the editor2 page and call this from the Chrome DevTools console:

       ui.openrouter.devtools.showOpenRouterSidebar()

   and to go back to what a user would see:

       ui.openrouter.devtools.hideOpenRouterSidebar()

   `^:export` survives the advanced compilation, same as
   `storrito.paywall/disablePaywall`.

   This is not a feature flag: there is no per-organization state, no
   flag to clean up afterwards, and no way to enable it for someone
   accidentally. When the feature is ready for users, the branch at the
   top of this stack points the sidebar rail at the panel and this
   namespace becomes redundant."
  (:require [ui.core]
            [ui.openrouter.catalog :as catalog]
            [ui.openrouter.sidebar-panel]))

(defn dispatch!
  [actions]
  (let [store (ui.core/get-store)]
    ((:replicant/dispatch! @store) {:actions actions})))

(defn ^:export showOpenRouterSidebar
  []
  (dispatch! [[:store/assoc-in [:editor2 :sidebar-panel] :openrouter]
              [:data/query catalog/models-query]]))

(defn ^:export hideOpenRouterSidebar
  []
  (dispatch! [[:store/assoc-in [:editor2 :sidebar-panel] :media]]))
